// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".menu-item span[data-v-6fd55bba],a.menu-item[data-v-6fd55bba]{color:#fff;border-color:#fff;font-family:Roboto,sans-serif;font-size:16px;font-weight:400;line-height:44px}.clickable[data-v-6fd55bba]{cursor:pointer}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
